/**
 * バイヤー別の値を管理するクラス
 *
 * @export KYMW2000Model
 * @class KYMW2000Model
 */
export class TempSelectedSummaryByBuyer {
  constructor(
    public SelectedNumList: {
			MediumType: string,
			MediumName: string,
			ClassCode: string,
			ClassName: string,
			BuyerCode: string,
			BuyerName: string,
			FreezedGoodsCount: number,
			RefrigeratedGoodsCount: number,
			RoomTempGoodsCount: number,
			VegetableGoodsCount: number,
			BreadGoodsCount: number,
			OtherStockedGoodsCount: number,
    }[],
    public SelectedTotalNum: {
			FreezedGoodsCount: number,
			RefrigeratedGoodsCount: number,
			RoomTempGoodsCount: number,
			VegetableGoodsCount: number,
			BreadGoodsCount: number,
			OtherStockedGoodsCount: number,
    },
  ) {}
}
